const getContactIds = (userList) => userList.map(({userId}) => userId);

const getEntitiesChanged = (initialEntities, entities) => {
	const changed = [];
	initialEntities.forEach(({entityId, checked, indeterminate}) => {
		const newEntity = entities.find((entity) => entity.entityId === entityId);
		if (newEntity && (newEntity.checked !== checked || newEntity.indeterminate !== indeterminate)) {
			changed.push({entityId, operation: newEntity.checked});
		}
		if (!newEntity && checked) {
			changed.push({entityId, operation: false});
		}
	});
	return changed;
};

const getDashboardViewsChanged = (initialViews, views) => {
	const changedViews = [];

	initialViews.forEach(({label, checked, indeterminate}) => {
		const newView = views.find((newView) => label === newView.label);
		if (checked && !newView.checked) changedViews.push({view: newView.key, operation: false});
		if ((!checked || (checked && indeterminate)) && newView.checked && !newView.indeterminate)
			changedViews.push({view: newView.key, operation: true});
	});

	return changedViews;
};

export default (initialValues, values, constants) => {
	const {
		USER_LIST,
		HAS_EXTERNAL,
		ENTITIES,
		DASHBOARD_VIEWS,
		ACCESS_TO_DASHBOARD,
		ACCESS_TO_CONTACT_LIST,
		ACCESS_TO_GROUP_RISK_ASSESMENT,
		PROJECT_OWNER_ACCESS,
		ENTITY_ADMIN_ACCESS,
		PROJECT_OWNER,
		ENTITY_ADMIN,
		USER
	} = constants;

	let makeApiCall = false;

	const contactIds = getContactIds(values[USER_LIST]);

	const changedEntities = getEntitiesChanged(initialValues[ENTITIES], values[ENTITIES]);

	const changedViews = getDashboardViewsChanged(initialValues[DASHBOARD_VIEWS], values[DASHBOARD_VIEWS]);

	const changedAccessToContacts = initialValues[ACCESS_TO_CONTACT_LIST] !== values[ACCESS_TO_CONTACT_LIST];

	const changedAccessToGroupRiskAssessment =
		initialValues[ACCESS_TO_GROUP_RISK_ASSESMENT] !== values[ACCESS_TO_GROUP_RISK_ASSESMENT];

	const changedInProjectOwner = initialValues[PROJECT_OWNER_ACCESS] !== values[PROJECT_OWNER_ACCESS];

	const changedInEntityAdmin = initialValues[ENTITY_ADMIN_ACCESS] !== values[ENTITY_ADMIN_ACCESS];

	if (
		changedEntities.length > 0 ||
		changedViews.length > 0 ||
		changedAccessToContacts ||
		changedAccessToGroupRiskAssessment ||
		changedInProjectOwner ||
		changedInEntityAdmin
	)
		makeApiCall = true;

	if (makeApiCall) {
		const payload = {
			contactIds,
			views: changedViews
		};

		if (changedEntities.length > 0) payload.entities = changedEntities;
		if (changedAccessToContacts) payload.hasContactListAccess = values[ACCESS_TO_CONTACT_LIST];
		if (changedAccessToGroupRiskAssessment) {
			payload.hasGroupRiskAssessmentAccess = values[ACCESS_TO_GROUP_RISK_ASSESMENT];
		}
		let userLevelAccess = USER;
		if (values[PROJECT_OWNER_ACCESS]) userLevelAccess = PROJECT_OWNER;
		if (values[ENTITY_ADMIN_ACCESS]) userLevelAccess = ENTITY_ADMIN;

		payload.userLevelAccess = userLevelAccess;

		if (payload.entities === null || payload.entities === undefined) {
			payload.entities = values[ENTITIES]?.filter((f) => f.checked);
		} else if (
			payload.entities?.length > 0 &&
			initialValues[ENTITY_ADMIN_ACCESS] === false &&
			values[ENTITY_ADMIN_ACCESS] === true
		) {
			const existingEntities = values[ENTITIES]?.filter(
				(entity) => !payload.entities.some((payloadEntity) => payloadEntity.entityId === entity.entityId)
			);
			existingEntities?.forEach((entity) => {
				payload.entities.push({...entity, userLevelAccess: ENTITY_ADMIN}); // CASE when entities are selected and it is selected as admin (change)
			});
		} else if (
			payload.entities?.length > 0 &&
			initialValues[ENTITY_ADMIN_ACCESS] === true &&
			values[ENTITY_ADMIN_ACCESS] === false
		) {
			values[ENTITIES].forEach((entity) => {
				payload.entities.push(entity); // CASE when entities are unselected and it is selected as not admin (change)
			});
		}

		return payload;
	}

	return false;
};
